export default class AlertBar {
	constructor(root) {
		this.root = root;
		this.closeBtn = root?.querySelector('.alert-bar-close');

		this.closeBtn?.addEventListener('click', () => {
			this.close();
		});

		if (window.localStorage.getItem(`alert-bar-${this.id}`) !== 'closed') {
			this.open();
		}
	}

	get id() {
		return this.root?.getAttribute('data-alert-id');
	}

	open() {
		this.root?.classList.add('active');
	}

	close() {
		this.root?.classList.remove('active');
		this.closeBtn?.setAttribute('tabindex', '-1');
		this.root?.querySelectorAll('a', (anchor) => {
			anchor.setAttribute('tabindex', '-1');
		});

		window.localStorage.setItem(`alert-bar-${this.id}`, 'closed');
	}
}
